import React from "react";
import { useParams } from "react-router-dom";
import PageVSheet from "../../component/PageVSheet";

export interface ApplicationProps {
  workflowTemplateId: string;
}

export default function ProjectDetail() {
  const params = useParams<ApplicationProps>();
  return (
    <>
      <PageVSheet
        workflowTemplateId={params.workflowTemplateId}
        dataId="0"
      ></PageVSheet>
    </>
  );
}
